/**
 * @internal
 */
export const IDs = {
  // classes
  cls: {
    scMenu: 'sc-menu',
  },
  attr: {
    toolbar: 'toolbar',
    toolbarData: 'data-toolbar',
    settings: 'settings',
    settingsData: 'data-settings',
  },
  publishAllowed: 'DraftOptional',
  sel: {
    scMenu: '.sc-menu',
    tagScMenu: 'ul.sc-menu',
  },
};
